import { create } from 'zustand';
import { authToken } from '@/api/auth-token';

interface AuthState {
  hasToken: boolean;
  refreshFromStorage: () => void;
  setHasToken: (v: boolean) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  hasToken: !!authToken.read()?.accessToken,
  refreshFromStorage: () => set({ hasToken: !!authToken.read()?.accessToken }),
  setHasToken: (v) => set({ hasToken: v }),
  logout: () => {
    authToken.clear();
    set({ hasToken: false });
  },
}));

// Subscribe to global logout event triggered by axios interceptor.
if (typeof window !== 'undefined') {
  window.addEventListener('syron:auth:logout', () => {
    useAuthStore.getState().logout();
  });
}
